@if (display$() && news$().length > 0) {
  <div class="news-ticker-container" [class.paused]="isPaused">
    <div class="bullhorn-icon">
      <nmfta-icon color="accent" name="bullhorn"></nmfta-icon>
    </div>

    <div class="news-ticker-content">
      @for (newsFeed of news$(); track $index) {
        <span class="news-item"
              (mouseenter)="pauseScroll()"
              (mouseleave)="resumeScroll()"
              [class.has-link]="newsFeed.link"
              [attr.tabindex]="newsFeed.link ? 0 : null"
              (click)="newsFeed.link ? openLink(newsFeed.link) : null"
              (keyup.enter)="newsFeed.link ? openLink(newsFeed.link) : null">
          {{ newsFeed.newsFeedMessage }}
          @if (newsFeed.link) {
            &nbsp;<span class="banner-link"> {{ 'ADMIN.NEWSFEED.CLICK_HERE' | translate }}.</span>
          }
        </span>
      }
    </div>
    <div class="close-icon gradient">
      <nmfta-button styleType="icon"
                    iconName="close"
                    class="close-button"
                    [isLoading]="isLoading$()"
                    (buttonClick)="hideBanner()">
      </nmfta-button>
    </div>
  </div>
}
